import React from "react";
import "./AdminTicket.css";
import expand from "./images/outline_expand_more_black_24dp.png";
import minimize from "./images/outline_expand_less_black_24dp.png";

class AdminTicket extends React.Component {
    constructor(props) {
        super(props);

        this.renderType = this.renderType.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.handleApproval = this.handleApproval.bind(this);
    }

    handleApproval(event) {
        let user = event.target.id.split("|")[0];
        let id = event.target.id.split("|")[1];
        this.props.approve(user, id, this.props.ticket.ticket_date, this.props.ticket.ticket_team)
    }


    toggleDropdown(event) {
        if(event.target.src === expand) {
            event.target.src = minimize;
            event.target.parentNode.parentNode.children[0].style.display = "flex";
        } else {
            event.target.src = expand;
            event.target.parentNode.parentNode.children[0].style.display = "none";
        }
    }

    renderType(released, requests, claimed) {
        if(released && !claimed) {
            return (
                <div className="requests">
                    <div className="request-container">
                        {requests.map(request => {
                            return (
                                <div key={request.timestamp} className="request">
                                    <p className="request-username">{request.email}</p>
                                    <p className="request-timestamp">{request.timestamp}</p>
                                    <p className="request-approval" id={`${request.email}|${this.props.ticket.id}`} onClick={this.handleApproval}>APPROVE</p>
                                </div>
                            );
                        })}
                    </div>
                    <div className="request-info">
                        <img src={expand} className="request-dropdown" onClick={this.toggleDropdown} alt="dropdown"/>
                        <p className="counter">{requests.length}</p>
                    </div>
                </div>
            );
        } else if (claimed) {
            return (
                <div className="claimed-message">
                    <h3>These tickets were claimed by {requests[0]}.</h3>
                </div>
            );
        }
        return (
            <p className="release-button" onClick={this.props.release}>RELEASE</p>
        );
    }

    render() {
        return (
            <div className="admin-ticket-container">
                <div id={this.props.ticket.id} className="top-ticket">
                    <h3>{this.props.ticket.ticket_date} - {this.props.ticket.ticket_team} Tickets</h3>
                    <div className="seat-info">
                        <p>Section: {this.props.ticket.seat_section}</p>
                        <p>Row: {this.props.ticket.seat_row}</p>
                        <p>Seats: {this.props.ticket.seat_numbers}</p>
                    </div>
                </div>
                {this.renderType(this.props.ticket.released, this.props.ticket.requests, this.props.ticket.claimed)}
            </div>
        )
    }
}

export default AdminTicket;